import React from 'react';
import ReactDOM from 'react-dom';
import { usePortal } from './use-portal';
/**
 * Компонент упрощает работу с порталами в React:
 *
 * 1. Предоставляет Portal как компонент
 * 1. Позволяет поменять место для вставки портала
 * 1. Может быть отключен
 *
 * React [Не поддерживает](https://github.com/facebook/react/issues/13097) порталы в SSR, что говорит о том,
 * что портал сможет отрисоваться только после гидрации на клиенте.
 * Если Вам необходимо отрисовать компонент внутри `<Portal />` на сервере, используйте prop `disabled`,
 * тогда контент будет вставлен непосредственно внутрь разметки.
 *
 * По умолчанию используется root, предоставляемый через `<ThemeProvider />`
 *
 * ***Важно***: компонент отображается не сразу при монтировании, а в следующем тике render.
 * Это связано с тем, что React не поддерживает порталы в SSR и при гидрации ему необходимо предоставить
 * ту же разметку что и при рендере на сервере. Если Вам нужно выполнить какие-то вычисления после монтирования портала,
 * используйте колбэк `onMount`
 *
 * @see https://reactjs.org/docs/portals.html
 *
 * @example ```jsx
 *  <div>
 *    Portal will be rendered outside of me!
 *
 *    <Portal>
 *      <div>some content will be showed outside of parent container</div>
 *    </Portal>
 *  </div>
 * ```
 */
export function Portal(props) {
  const {
    children,
    mountRoot,
    disabled
  } = usePortal(props);
  if (disabled) return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  return mountRoot ? /*#__PURE__*/ReactDOM.createPortal(children, mountRoot) : null;
}